// extracted by mini-css-extract-plugin
export default {"bg":"GlobalEcards_bg__MgDGS","content":"GlobalEcards_content__j6W6U"};